<div class="track-marker-box">
  @if (isPromo) {
    <span class="track-marker currency-sign">{{ currencySign }}</span>
  } @else {
    <div class="track-marker-box">
      <span class="track-marker ordinal-number">{{ ordinalNumber }}</span>
    </div>
  }
</div>
